import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__hashCode_impl_fhcsz25lnxnw796huh as MonetaryValue__hashCode_impl_fhcsz2,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__rangeTo_impl_1k0odj1ncwos3p2ntha as MonetaryValue__rangeTo_impl_1k0odj,
  MonetaryValueRange__toString_impl_eede0o29kkga5u337ce as MonetaryValueRange__toString_impl_eede0o,
  MonetaryValueRange__contains_impl_7d4u172030w1fl7pfl7 as MonetaryValueRange__contains_impl_7d4u17,
} from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  rerunOn28vy04vs1j44i as rerunOn,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { printHtml1fhajl0naptyz as printHtml } from '../../actuals/printing.js.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { filterNotNullhujglslymx1l as filterNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  weightt34o7llf2uyq as weight,
  shownWhenxgf1ujy6rmvr as shownWhen,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  body3i5t0n7zprpqb as body,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  title1nssp3ryhwuqj as title,
} from '../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  reactive2pl1t9wy5gll5 as reactive,
  reactiveScope1fcalsbdr0hgb as reactiveScope,
} from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  get_section1qyzr1npzel2z as get_section,
  get_lightSection4cpu8okr0w14 as get_lightSection,
} from '../theming/sections.mjs';
import {
  get_italic11nskfy97pz2f as get_italic,
  get_compact3lsezez8nz8b6 as get_compact,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  SharedUtils_getInstanceggolgle4lzs6 as SharedUtils_getInstance,
  RequiredTransferMethod_CheckOrWire_getInstance2c8njn9raqmay as RequiredTransferMethod_CheckOrWire_getInstance,
  RequiredTransferMethod_ACH_getInstance3m8mkmk5y1ml8 as RequiredTransferMethod_ACH_getInstance,
} from '../../../../../crowpay-shared/com/crowpay/sharedUtils.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
  Set2awzlbbrsme5i as Set,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { notificationBar4efejtg2792g as notificationBar } from '../theming/banners.mjs';
import { text1v7b2bj2gx49v as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  isBlank1dvkhjjvox3p0 as isBlank,
  trim11nh7r46at6sx as trim,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  singleo93pzdgfc557 as single,
  sortedWith2csnbbb21k0lg as sortedWith,
  plus20p0vtfmu0596 as plus,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { label287uhiq3m9m4z as label2 } from '../components/label2.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_0,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_money1hho0fu3wco2x as get_money,
  resize3py5p2yrjp6p7 as resize,
} from '../../utils/utils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { get_bank374yxon6d2xhn as get_bank } from '../../icons.mjs';
import {
  Companion_getInstancecudcwq8yu3m7 as Companion_getInstance_1,
  get_selectedApi2skzkr2pn0lot as get_selectedApi,
} from '../../sdk/apiOptions.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { set_value1vvx5pkb20ebv as set_value } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
import {
  PaymentMethod1x8gg38hdlghq as PaymentMethod,
  PaymentRequest2wgfbtpc9jnmf as PaymentRequest,
} from '../../../../../crowpay-shared/com/crowpay/paymentModels.mjs';
import { confirmationDialog1lynowl7yd4cd as confirmationDialog } from './GenericConfirmationDialog.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance_2 } from '../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from './GenericDialog.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  isCharSequence1ju9jr1w86plq as isCharSequence,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/LsErrorException.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { SetupCustomerMethodDialog2y75086l50hfg as SetupCustomerMethodDialog } from './SetupCustomerMethodDialog.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  BasicListenable3uz4a8xs34a0h as BasicListenable,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { validated3dw9xce8adqbh as validated } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { mutableRemember1h6fyyolumj0o as mutableRemember } from '../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { get_appThemejy2o9bdilpry as get_appTheme } from '../theming/appTheme.mjs';
import { RadioButton1rpamcjl5aybg as RadioButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioButton.commonHtml.mjs';
import { equalTo2dio0vrcsd3je as equalTo } from '../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { assertReactive30c64mz7ckt8m as assertReactive } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { MonetaryValueInput2lk8s753hzo22 as MonetaryValueInput } from '../components/MonetaryValueInput.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PayRequestedClass;
function PayRequested() {
  if (PayRequestedClass === VOID) {
    class $ extends MakePaymentIntent() {
      constructor(requests) {
        super();
        this.qid_1 = requests;
      }
      toString() {
        return 'PayRequested(requests=' + toString(this.qid_1) + ')';
      }
      hashCode() {
        return hashCode(this.qid_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PayRequested()))
          return false;
        if (!equals(this.qid_1, other.qid_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PayRequested');
    PayRequestedClass = $;
  }
  return PayRequestedClass;
}
var PayUnrequestedClass;
function PayUnrequested() {
  if (PayUnrequestedClass === VOID) {
    class $ extends MakePaymentIntent() {
      constructor() {
        PayUnrequested_instance = null;
        super();
        PayUnrequested_instance = this;
      }
      toString() {
        return 'PayUnrequested';
      }
      hashCode() {
        return 1474311284;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PayUnrequested()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'PayUnrequested');
    PayUnrequestedClass = $;
  }
  return PayUnrequestedClass;
}
var PayUnrequested_instance;
function PayUnrequested_getInstance() {
  if (PayUnrequested_instance === VOID)
    new (PayUnrequested())();
  return PayUnrequested_instance;
}
var PayForChangeClass;
function PayForChange() {
  if (PayForChangeClass === VOID) {
    class $ extends MakePaymentIntent() {
      constructor(changeAmount) {
        super();
        this.rid_1 = changeAmount;
      }
      toString() {
        return 'PayForChange(changeAmount=' + MonetaryValue__toString_impl_xslc77(this.rid_1) + ')';
      }
      hashCode() {
        return MonetaryValue__hashCode_impl_fhcsz2(this.rid_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PayForChange()))
          return false;
        if (!(this.rid_1 === other.rid_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PayForChange');
    PayForChangeClass = $;
  }
  return PayForChangeClass;
}
var PayRemainingToCompleteProjectClass;
function PayRemainingToCompleteProject() {
  if (PayRemainingToCompleteProjectClass === VOID) {
    class $ extends MakePaymentIntent() {
      constructor() {
        PayRemainingToCompleteProject_instance = null;
        super();
        PayRemainingToCompleteProject_instance = this;
      }
      toString() {
        return 'PayRemainingToCompleteProject';
      }
      hashCode() {
        return 2010673904;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PayRemainingToCompleteProject()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'PayRemainingToCompleteProject');
    PayRemainingToCompleteProjectClass = $;
  }
  return PayRemainingToCompleteProjectClass;
}
var PayRemainingToCompleteProject_instance;
function PayRemainingToCompleteProject_getInstance() {
  if (PayRemainingToCompleteProject_instance === VOID)
    new (PayRemainingToCompleteProject())();
  return PayRemainingToCompleteProject_instance;
}
var MakePaymentIntentClass;
function MakePaymentIntent() {
  if (MakePaymentIntentClass === VOID) {
    class $ {}
    initMetadataForClass($, 'MakePaymentIntent');
    MakePaymentIntentClass = $;
  }
  return MakePaymentIntentClass;
}
var ConstantClass;
function Constant() {
  if (ConstantClass === VOID) {
    class $ {
      constructor(key, value, bold) {
        this.sid_1 = key;
        this.tid_1 = value;
        this.uid_1 = bold;
      }
      toString() {
        return 'Constant(key=' + this.sid_1 + ', value=' + this.tid_1 + ', bold=' + this.uid_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.sid_1);
        result = imul(result, 31) + getStringHashCode(this.tid_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.uid_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Constant()))
          return false;
        if (!(this.sid_1 === other.sid_1))
          return false;
        if (!(this.tid_1 === other.tid_1))
          return false;
        if (!(this.uid_1 === other.uid_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Constant');
    ConstantClass = $;
  }
  return ConstantClass;
}
var ReactiveClass;
function Reactive() {
  if (ReactiveClass === VOID) {
    class $ {
      constructor(key, calculate, bold) {
        this.vid_1 = key;
        this.wid_1 = calculate;
        this.xid_1 = bold;
      }
      toString() {
        return 'Reactive(key=' + this.vid_1 + ', calculate=' + toString(this.wid_1) + ', bold=' + this.xid_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.vid_1);
        result = imul(result, 31) + hashCode(this.wid_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.xid_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Reactive()))
          return false;
        if (!(this.vid_1 === other.vid_1))
          return false;
        if (!equals(this.wid_1, other.wid_1))
          return false;
        if (!(this.xid_1 === other.xid_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Reactive');
    ReactiveClass = $;
  }
  return ReactiveClass;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.yid_1.pc();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.vfw().rfg_1.ofp($this.zid_1.aie_1.v7a_1, $this.zid_1.cie_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = printHtml(tmp, tmp_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.fie_1.pc();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.vfw().rfg_1.pfp($this.gie_1.aie_1.v7a_1, $this.gie_1.cie_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = printHtml(tmp, tmp_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function to($this, _this__u8e3s4, value) {
  return new (Constant())(_this__u8e3s4, value, true);
}
function to_0($this, _this__u8e3s4, value, bold) {
  return new (Constant())(_this__u8e3s4, value, bold);
}
function to_1($this, _this__u8e3s4, bold, value) {
  return new (Reactive())(_this__u8e3s4, value, bold);
}
function to$default($this, _this__u8e3s4, bold, value, $super) {
  bold = bold === VOID ? true : bold;
  return to_1($this, _this__u8e3s4, bold, value);
}
function tableOf($this, _this__u8e3s4, entries) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  var _iterator__ex2g4s = filterNotNull(entries).m1();
  while (_iterator__ex2g4s.n1()) {
    var entry = _iterator__ex2g4s.o1();
    if (entry instanceof Constant()) {
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (RowOrCol())(view.pc());
      var tmp0_elvis_lhs_0 = view.ebb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.gbb(p_0, view_0);
      view_0.zbm(false);
      view_0.lbb(weight(view_0, 1.0), body(view_0, entry.sid_1));
      var tmp = weight(view_0, 2.5);
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (TextView())(view_0.pc());
      var tmp0_elvis_lhs_1 = view_0.ebb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
      view_0.gbb(p_1, view_1);
      view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
      if (entry.uid_1) {
        view_1.lba(view_1.qb6_1.abf(BoldSemantic_getInstance()));
      }
      view_1.ccp(entry.tid_1);
      view_0.hbb(p_1, view_1);
      view_0.lbb(tmp, view_1);
      view.hbb(p_0, view_0);
    } else {
      if (entry instanceof Reactive()) {
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_2 = view.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.gbb(p_2, view_2);
        view_2.zbm(false);
        view_2.lbb(weight(view_2, 1.0), body(view_2, entry.vid_1));
        var tmp_0 = weight(view_2, 2.5);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (TextView())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.lba(view_3.qb6_1.abf(BodySemantic_getInstance()));
        if (entry.xid_1) {
          view_3.lba(view_3.qb6_1.abf(BoldSemantic_getInstance()));
        }
        reactive(view_3, MakePaymentInfoBandaidDialog$tableOf$lambda(view_3, entry));
        view_2.hbb(p_3, view_3);
        view_2.lbb(tmp_0, view_3);
        view.hbb(p_2, view_2);
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  _this__u8e3s4.hbb(p, view);
  return view;
}
function payByCheck($this) {
  var tmp = get_dialogStack();
  return tmp.vh2(VOID, VOID, ($this$dialog, it) => {
    var tmp = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_rem(45));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$dialog.pc());
    var tmp0_elvis_lhs = $this$dialog.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
    $this$dialog.gbb(p, view);
    view.zbm(true);
    title(view, 'Pay by Check or Online Bill Pay');
    body(view, 'Most banks let you send a check through their online bill pay \u2014 your bank prints and mails the check on your behalf, usually free. This is often the easiest option. The payee info is the same whether you write your own check or use bill pay.');
    view.lbb(get_section(view), tableOf($this, view, [to($this, 'Make check payable to', 'Stoze LLC'), to($this, 'Mail to', 'PO Box 184, Providence, UT 84332'), to($this, 'Amount', MonetaryValue__toString_impl_xslc77($this.cie_1)), to_0($this, 'Memo line', 'Write <strong>' + $this.aie_1.q97() + '<\/strong> on the memo line (you can also add the project name)', false)]));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.lba(view_0.qb6_1.abf(BodySemantic_getInstance()));
    view_0.ccp('Questions about your payment? Email <a href=mailto:books@stoze.io>books@stoze.io<\/a>.');
    view.hbb(p_0, view_0);
    view.lbb(get_italic(view), body(view, "Once your funds are processed, you'll receive an email and your project status will update. Allow up to a week for processing after Stoze receives your funds; mailed checks add transit time on top of that."));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_1 = view.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.gbb(p_1, view_1);
    view_1.zbm(false);
    var tmp_0 = get_primaryButton(view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Button())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.gbb(p_2, view_2);
    specCenteredText(view_2, 'Print Payment Slip');
    onClick(view_2, VOID, VOID, MakePaymentInfoBandaidDialog$payByCheck$lambda$slambda_0(view_2, $this));
    view_1.hbb(p_2, view_2);
    view_1.lbb(tmp_0, view_2);
    var tmp_1 = get_secondaryButton(view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Button())(view_1.pc());
    var tmp0_elvis_lhs_3 = view_1.ebb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
    view_1.gbb(p_3, view_3);
    specCenteredText(view_3, 'Go Back');
    onClick(view_3, VOID, VOID, MakePaymentInfoBandaidDialog$payByCheck$lambda$slambda_2());
    view_1.hbb(p_3, view_3);
    view_1.lbb(tmp_1, view_3);
    view.hbb(p_1, view_1);
    $this$dialog.hbb(p, view);
    return $this$dialog.lbb(tmp, view);
  });
}
function payByWire($this) {
  var tmp = get_dialogStack();
  return tmp.vh2(VOID, VOID, ($this$dialog, it) => {
    var tmp = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_rem(45));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$dialog.pc());
    var tmp0_elvis_lhs = $this$dialog.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
    $this$dialog.gbb(p, view);
    view.zbm(true);
    title(view, 'Pay by Wire');
    view.lbb(get_section(view), tableOf($this, view, [to($this, 'Bank', 'Cache Valley Bank'), to($this, 'Routing number (ABA)', '124302325'), to($this, 'Account number', '67207528'), to($this, 'Beneficiary name', 'Stoze LLC (Trust Account)'), to($this, 'Beneficiary address', '2906 South Hwy 89, Nibley, UT 84321'), to($this, 'Amount', MonetaryValue__toString_impl_xslc77($this.cie_1)), to($this, 'Reference / memo', $this.aie_1.q97())]));
    questionsAboutYourPayment($this, view);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.lba(view_0.qb6_1.abf(BodySemantic_getInstance()));
    view_0.ccp('After sending, you can email your wire confirmation to <a href=mailto:books@stoze.io>books@stoze.io<\/a> to speed up crediting.');
    view.hbb(p_0, view_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_1 = view.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.gbb(p_1, view_1);
    view_1.zbm(false);
    var tmp_0 = get_primaryButton(view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (Button())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.gbb(p_2, view_2);
    specCenteredText(view_2, 'Print Wire Instructions');
    onClick(view_2, VOID, VOID, MakePaymentInfoBandaidDialog$payByWire$lambda$slambda_0(view_2, $this));
    view_1.hbb(p_2, view_2);
    view_1.lbb(tmp_0, view_2);
    var tmp_1 = get_secondaryButton(view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Button())(view_1.pc());
    var tmp0_elvis_lhs_3 = view_1.ebb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
    view_1.gbb(p_3, view_3);
    specCenteredText(view_3, 'Go Back');
    onClick(view_3, VOID, VOID, MakePaymentInfoBandaidDialog$payByWire$lambda$slambda_2());
    view_1.hbb(p_3, view_3);
    view_1.lbb(tmp_1, view_3);
    view.hbb(p_1, view_1);
    $this$dialog.hbb(p, view);
    return $this$dialog.lbb(tmp, view);
  });
}
function questionsAboutYourPayment($this, _this__u8e3s4) {
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.lba(view.qb6_1.abf(BodySemantic_getInstance()));
  view.ccp('Questions about your payment? Email <a href=mailto:books@stoze.io>books@stoze.io<\/a>.');
  _this__u8e3s4.hbb(p, view);
  return view;
}
var MakePaymentInfoBandaidDialog$render$slambdaClass;
function MakePaymentInfoBandaidDialog$render$slambda() {
  if (MakePaymentInfoBandaidDialog$render$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentInfoBandaidDialog$render$slambdaClass = $;
  }
  return MakePaymentInfoBandaidDialog$render$slambdaClass;
}
function MakePaymentInfoBandaidDialog$render$slambda_0() {
  var i = new (MakePaymentInfoBandaidDialog$render$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MakePaymentInfoBandaidDialog$render$slambdaClass_0;
function MakePaymentInfoBandaidDialog$render$slambda_1() {
  if (MakePaymentInfoBandaidDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.hie_1 = this$0;
      }
      uao($completion) {
        payByCheck(this.hie_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentInfoBandaidDialog$render$slambdaClass_0 = $;
  }
  return MakePaymentInfoBandaidDialog$render$slambdaClass_0;
}
function MakePaymentInfoBandaidDialog$render$slambda_2(this$0) {
  var i = new (MakePaymentInfoBandaidDialog$render$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MakePaymentInfoBandaidDialog$render$slambdaClass_1;
function MakePaymentInfoBandaidDialog$render$slambda_3() {
  if (MakePaymentInfoBandaidDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.iie_1 = this$0;
      }
      uao($completion) {
        payByWire(this.iie_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentInfoBandaidDialog$render$slambdaClass_1 = $;
  }
  return MakePaymentInfoBandaidDialog$render$slambdaClass_1;
}
function MakePaymentInfoBandaidDialog$render$slambda_4(this$0) {
  var i = new (MakePaymentInfoBandaidDialog$render$slambda_3())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MakePaymentInfoBandaidDialog$render$slambdaClass_2;
function MakePaymentInfoBandaidDialog$render$slambda_5() {
  if (MakePaymentInfoBandaidDialog$render$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0) {
        this.jie_1 = this$0;
      }
      uao($completion) {
        get_dialogStack().gbw(new (MakePaymentDialog())(this.jie_1.aie_1, this.jie_1.cie_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentInfoBandaidDialog$render$slambdaClass_2 = $;
  }
  return MakePaymentInfoBandaidDialog$render$slambdaClass_2;
}
function MakePaymentInfoBandaidDialog$render$slambda_6(this$0) {
  var i = new (MakePaymentInfoBandaidDialog$render$slambda_5())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MakePaymentInfoBandaidDialog$render$slambdaClass_3;
function MakePaymentInfoBandaidDialog$render$slambda_7() {
  if (MakePaymentInfoBandaidDialog$render$slambdaClass_3 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentInfoBandaidDialog$render$slambdaClass_3 = $;
  }
  return MakePaymentInfoBandaidDialog$render$slambdaClass_3;
}
function MakePaymentInfoBandaidDialog$render$slambda_8() {
  var i = new (MakePaymentInfoBandaidDialog$render$slambda_7())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function MakePaymentInfoBandaidDialog$tableOf$lambda($$this$body, $entry) {
  return ($this$reactive) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$0 = $entry.wid_1($this$reactive);
    $$this$body.ccp(tmp$ret$0);
    return Unit_instance;
  };
}
var MakePaymentInfoBandaidDialog$payByCheck$lambda$slambdaClass;
function MakePaymentInfoBandaidDialog$payByCheck$lambda$slambda() {
  if (MakePaymentInfoBandaidDialog$payByCheck$lambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.yid_1 = $$this$button;
        this.zid_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentInfoBandaidDialog$payByCheck$lambda$slambdaClass = $;
  }
  return MakePaymentInfoBandaidDialog$payByCheck$lambda$slambdaClass;
}
function MakePaymentInfoBandaidDialog$payByCheck$lambda$slambda_0($$this$button, this$0) {
  var i = new (MakePaymentInfoBandaidDialog$payByCheck$lambda$slambda())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MakePaymentInfoBandaidDialog$payByCheck$lambda$slambdaClass_0;
function MakePaymentInfoBandaidDialog$payByCheck$lambda$slambda_1() {
  if (MakePaymentInfoBandaidDialog$payByCheck$lambda$slambdaClass_0 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentInfoBandaidDialog$payByCheck$lambda$slambdaClass_0 = $;
  }
  return MakePaymentInfoBandaidDialog$payByCheck$lambda$slambdaClass_0;
}
function MakePaymentInfoBandaidDialog$payByCheck$lambda$slambda_2() {
  var i = new (MakePaymentInfoBandaidDialog$payByCheck$lambda$slambda_1())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MakePaymentInfoBandaidDialog$payByWire$lambda$slambdaClass;
function MakePaymentInfoBandaidDialog$payByWire$lambda$slambda() {
  if (MakePaymentInfoBandaidDialog$payByWire$lambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.fie_1 = $$this$button;
        this.gie_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentInfoBandaidDialog$payByWire$lambda$slambdaClass = $;
  }
  return MakePaymentInfoBandaidDialog$payByWire$lambda$slambdaClass;
}
function MakePaymentInfoBandaidDialog$payByWire$lambda$slambda_0($$this$button, this$0) {
  var i = new (MakePaymentInfoBandaidDialog$payByWire$lambda$slambda())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MakePaymentInfoBandaidDialog$payByWire$lambda$slambdaClass_0;
function MakePaymentInfoBandaidDialog$payByWire$lambda$slambda_1() {
  if (MakePaymentInfoBandaidDialog$payByWire$lambda$slambdaClass_0 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentInfoBandaidDialog$payByWire$lambda$slambdaClass_0 = $;
  }
  return MakePaymentInfoBandaidDialog$payByWire$lambda$slambdaClass_0;
}
function MakePaymentInfoBandaidDialog$payByWire$lambda$slambda_2() {
  var i = new (MakePaymentInfoBandaidDialog$payByWire$lambda$slambda_1())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MakePaymentInfoBandaidDialogClass;
function MakePaymentInfoBandaidDialog() {
  if (MakePaymentInfoBandaidDialogClass === VOID) {
    class $ {
      constructor(project, intent, amount) {
        var tmp;
        if (amount === VOID) {
          var tmp_0;
          if (intent instanceof PayRequested()) {
            // Inline function 'com.crowpay.extensions.sumMoney' call
            var this_0 = intent.qid_1;
            var sum = Companion_instance.r91(0n);
            var _iterator__ex2g4s = this_0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp_1 = sum;
              var tmp$ret$0 = MonetaryValue__minus_impl_jw9qyp(MonetaryValue__minus_impl_jw9qyp(element.g61_1, element.j61_1), element.i61_1);
              sum = MonetaryValue__plus_impl_c1ylt(tmp_1, tmp$ret$0);
            }
            tmp_0 = sum;
          } else {
            if (intent instanceof PayForChange()) {
              tmp_0 = intent.rid_1;
            } else {
              if (equals(intent, PayUnrequested_getInstance())) {
                tmp_0 = project.s97();
              } else {
                if (equals(intent, PayRemainingToCompleteProject_getInstance())) {
                  tmp_0 = project.s97();
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
          tmp = tmp_0;
        } else {
          tmp = amount;
        }
        amount = tmp;
        this.aie_1 = project;
        this.bie_1 = intent;
        this.cie_1 = amount;
        var tmp_2 = this;
        tmp_2.die_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.eaj($this$remember.daj(get_session()).lfv_1.geo(this.aie_1.x7a_1)));
        this.eie_1 = SharedUtils_getInstance().q9s(this.cie_1);
      }
      wd6(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(MakePaymentInfoBandaidDialog$render$slambda_0());
        view.gba(get_AppDimensions().yg1_1);
        var tmp_0 = view.kbb(view.kbb(get_centered(view), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(40))), view.jbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        title(view_0, 'Send Escrow Funds for ' + this.aie_1.b7b_1 + ' (#' + this.aie_1.q97() + ')');
        var tmp_1;
        switch (this.eie_1.b4_1) {
          case 0:
            tmp_1 = 'Stoze accepts escrow funds for payments of this size by secure bank transfer (ACH) through Stripe on behalf of your contractor. Link your bank account and your payment will be credited to your project automatically.';
            break;
          case 1:
            tmp_1 = 'Stoze currently accepts escrow funds by check or wire transfer on behalf of your contractor. Choose whichever method works for you. Include your project reference number on the check memo or with your wire so we can credit your project correctly.';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        body(view_0, tmp_1);
        var tmp_2;
        var tmp_3 = this.bie_1;
        if (tmp_3 instanceof PayForChange()) {
          tmp_2 = true;
        } else {
          tmp_2 = equals(this.bie_1, PayUnrequested_getInstance());
        }
        if (tmp_2) {
          var tmp_4 = notificationBar(view_0, AppColors_getInstance().lfz_1);
          var tmp1_subject = this.bie_1;
          var tmp_5;
          if (tmp1_subject instanceof PayForChange()) {
            tmp_5 = "You're funding an approved change order. Your contractor hasn't formally requested these funds yet, but sending them now ensures they're ready when work on the change order begins.";
          } else {
            if (equals(tmp1_subject, PayUnrequested_getInstance())) {
              tmp_5 = 'There is an outstanding balance of ' + MonetaryValue__toString_impl_xslc77(this.aie_1.s97()) + " on your project, but your contractor hasn't formally requested these funds yet. You can send funds now to ensure they're available when work begins, or wait until your contractor requests them.";
            } else {
              tmp_5 = '';
            }
          }
          view_0.lbb(tmp_4, text(view_0, tmp_5));
        }
        var tmp_6 = get_lightSection(view_0);
        var tmp_7 = to(this, 'Project Reference', this.aie_1.q97());
        var tmp_8 = to(this, 'Project Name', this.aie_1.b7b_1);
        var tmp_9 = to$default(this, 'Contractor', VOID, ($this$to) => $this$to.daj(this.die_1).v5i_1);
        var tmp2_subject = this.bie_1;
        var tmp_10;
        if (tmp2_subject instanceof PayForChange()) {
          tmp_10 = 'Change Amount';
        } else {
          if (tmp2_subject instanceof PayRequested()) {
            tmp_10 = 'Amount Due';
          } else {
            if (equals(tmp2_subject, PayRemainingToCompleteProject_getInstance())) {
              tmp_10 = 'Remaining Amount';
            } else {
              if (equals(tmp2_subject, PayUnrequested_getInstance())) {
                tmp_10 = 'Remaining Amount';
              } else {
                noWhenBranchMatchedException();
              }
            }
          }
        }
        view_0.lbb(tmp_6, tableOf(this, view_0, [tmp_7, tmp_8, tmp_9, to(this, tmp_10, MonetaryValue__toString_impl_xslc77(this.cie_1))]));
        var tmp_11 = this.bie_1;
        var tmp3_safe_receiver = tmp_11 instanceof PayRequested() ? tmp_11 : null;
        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.qid_1;
        var tmp_12;
        if (tmp4_safe_receiver == null) {
          tmp_12 = null;
        } else {
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp4_safe_receiver.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            // Inline function 'kotlin.text.isNotBlank' call
            var this_0 = element.h61_1;
            if (!isBlank(this_0)) {
              destination.v(element);
            }
          }
          tmp_12 = destination;
        }
        // Inline function 'kotlin.collections.orEmpty' call
        var tmp0_elvis_lhs_1 = tmp_12;
        var withNotes = tmp0_elvis_lhs_1 == null ? emptyList() : tmp0_elvis_lhs_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!withNotes.i1()) {
          var tmp_13 = notificationBar(view_0, AppColors_getInstance().lfz_1);
          var tmp_14 = withNotes.p1() === 1 ? 'Note From Contractor' : 'Notes From Contractor';
          view_0.lbb(tmp_13, label2(view_0, tmp_14, VOID, ($this$label2) => {
            var tmp;
            if (withNotes.p1() === 1) {
              tmp = body($this$label2, single(withNotes).h61_1);
            } else {
              // Inline function 'com.lightningkite.kiteui.views.direct.col' call
              // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
              var view = new (RowOrCol())($this$label2.pc());
              var tmp0_elvis_lhs = $this$label2.ebb_1;
              var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
              $this$label2.gbb(p, view);
              view.zbm(true);
              var _iterator__ex2g4s = withNotes.m1();
              while (_iterator__ex2g4s.n1()) {
                var request = _iterator__ex2g4s.o1();
                body(view, 'Request: ' + MonetaryValue__toString_impl_xslc77(request.g61_1) + '\n' + request.h61_1);
              }
              $this$label2.hbb(p, view);
              tmp = view;
            }
            return tmp;
          }));
        }
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        var tmp0_vertical = get_rem_0(1.5);
        var tmp1_horizontal = get_rem(2);
        view_1.jba(Edges().ed0(tmp1_horizontal, tmp0_vertical));
        if (this.eie_1.equals(RequiredTransferMethod_CheckOrWire_getInstance())) {
          var tmp_15 = get_secondaryButton(view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Button())(view_1.pc());
          var tmp0_elvis_lhs_3 = view_1.ebb_1;
          var p_2 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
          view_1.gbb(p_2, view_2);
          var tmp_16 = get_centered(view_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (RowOrCol())(view_2.pc());
          var tmp0_elvis_lhs_4 = view_2.ebb_1;
          var p_3 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
          view_2.gbb(p_3, view_3);
          view_3.zbm(false);
          view_3.lbb(get_centered(view_3), icon(view_3, resize(get_money(Companion_getInstance_0()), get_rem_0(1.2)), 'money'));
          view_3.lbb(get_centered(view_3), body(view_3, 'Pay by Check or Online Bill Pay'));
          onClick(view_2, VOID, VOID, MakePaymentInfoBandaidDialog$render$slambda_2(this));
          view_2.hbb(p_3, view_3);
          view_2.lbb(tmp_16, view_3);
          view_1.hbb(p_2, view_2);
          view_1.lbb(tmp_15, view_2);
          var tmp_17 = get_secondaryButton(view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_4 = new (Button())(view_1.pc());
          var tmp0_elvis_lhs_5 = view_1.ebb_1;
          var p_4 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
          view_1.gbb(p_4, view_4);
          var tmp_18 = get_centered(view_4);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (RowOrCol())(view_4.pc());
          var tmp0_elvis_lhs_6 = view_4.ebb_1;
          var p_5 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
          view_4.gbb(p_5, view_5);
          view_5.zbm(false);
          view_5.lbb(get_centered(view_5), icon(view_5, resize(get_bank(Companion_getInstance_0()), get_rem_0(1.2)), 'bank'));
          view_5.lbb(get_centered(view_5), body(view_5, 'Pay by Wire'));
          onClick(view_4, VOID, VOID, MakePaymentInfoBandaidDialog$render$slambda_4(this));
          view_4.hbb(p_5, view_5);
          view_4.lbb(tmp_18, view_5);
          view_1.hbb(p_4, view_4);
          view_1.lbb(tmp_17, view_4);
        }
        var tmp_19 = view_1.kbb(shownWhen(view_1, VOID, ($this$shownWhen) => this.eie_1.equals(RequiredTransferMethod_ACH_getInstance()) || Companion_getInstance_1().efx_1.t1($this$shownWhen.daj(get_selectedApi()))), get_secondaryButton(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Button())(view_1.pc());
        var tmp0_elvis_lhs_7 = view_1.ebb_1;
        var p_6 = tmp0_elvis_lhs_7 == null ? view_1 : tmp0_elvis_lhs_7;
        view_1.gbb(p_6, view_6);
        var tmp_20 = get_centered(view_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (RowOrCol())(view_6.pc());
        var tmp0_elvis_lhs_8 = view_6.ebb_1;
        var p_7 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
        view_6.gbb(p_7, view_7);
        view_7.zbm(false);
        view_7.lbb(get_centered(view_7), icon(view_7, resize(get_bank(Companion_getInstance_0()), get_rem_0(1.2)), 'transfer'));
        var tmp_21 = get_centered(view_7);
        var tmp_22;
        switch (this.eie_1.b4_1) {
          case 0:
            tmp_22 = 'Pay With Stripe';
            break;
          case 1:
            tmp_22 = 'Pay With Stripe (Only Visible for Dev Testing)';
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        view_7.lbb(tmp_21, body(view_7, tmp_22));
        onClick(view_6, VOID, VOID, MakePaymentInfoBandaidDialog$render$slambda_6(this));
        view_6.hbb(p_7, view_7);
        view_6.lbb(tmp_20, view_7);
        view_1.hbb(p_6, view_6);
        view_1.lbb(tmp_19, view_6);
        view_0.hbb(p_1, view_1);
        var tmp_23 = get_italic(view_0);
        var tmp_24;
        switch (this.eie_1.b4_1) {
          case 0:
            tmp_24 = "Bank transfers can take 3-5 business days to clear. You'll get an email when your funds are processed and your project status is updated.";
            break;
          case 1:
            tmp_24 = "Allow up to a week for processing after Stoze receives your funds. Mailed checks add transit time on top of that. You'll get an email when your funds are processed and your project status is updated.";
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        view_0.lbb(tmp_23, body(view_0, tmp_24));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Space())(view_0.pc());
        var tmp0_elvis_lhs_9 = view_0.ebb_1;
        var p_8 = tmp0_elvis_lhs_9 == null ? view_0 : tmp0_elvis_lhs_9;
        view_0.gbb(p_8, view_8);
        view_0.hbb(p_8, view_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_10 = view_0.ebb_1;
        var p_9 = tmp0_elvis_lhs_10 == null ? view_0 : tmp0_elvis_lhs_10;
        view_0.gbb(p_9, view_9);
        view_9.zbm(false);
        var tmp_25 = view_9.kbb(get_centered(view_9), get_primaryButton(view_9));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (Button())(view_9.pc());
        var tmp0_elvis_lhs_11 = view_9.ebb_1;
        var p_10 = tmp0_elvis_lhs_11 == null ? view_9 : tmp0_elvis_lhs_11;
        view_9.gbb(p_10, view_10);
        specCenteredText(view_10, 'Close');
        onClick(view_10, VOID, VOID, MakePaymentInfoBandaidDialog$render$slambda_8());
        view_9.hbb(p_10, view_10);
        view_9.lbb(tmp_25, view_10);
        view_0.hbb(p_9, view_9);
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'MakePaymentInfoBandaidDialog', VOID, VOID, [Page()]);
    MakePaymentInfoBandaidDialogClass = $;
  }
  return MakePaymentInfoBandaidDialogClass;
}
function *_generator_invoke__zhh2q8_1($this, $this$rememberSuspending, $completion) {
  var tmp = rerunOn($this.sie_1.oie_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.vfw().dfh_1.mfs($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'kotlin.collections.sortedBy' call
  var this_1 = tmp_1;
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_2 = MakePaymentDialog$methods$slambda$lambda;
  var tmp$ret$1 = new (sam$kotlin_Comparator$0())(tmp_2);
  return sortedWith(this_1, tmp$ret$1);
}
function MakePaymentDialog$methods$slambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.k70_1;
  var tmp$ret$1 = b.k70_1;
  return compareValues(tmp, tmp$ret$1);
}
function *_generator_invoke__zhh2q8_2($this, $this$SetupCustomerMethodDialog, newMethod, $completion) {
  $this.tie_1.oie_1.qaq();
  var tmp = awaitOnce($this.tie_1.pie_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.find' call
  var tmp0 = tmp;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.h70_1 === newMethod.h70_1) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp$ret$2 = tmp$ret$1;
  set_value($this.tie_1.qie_1, tmp$ret$2);
  return Unit_instance;
}
var MakePaymentDialog$render$slambda$slambdaClass;
function MakePaymentDialog$render$slambda$slambda() {
  if (MakePaymentDialog$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.tie_1 = this$0;
      }
      sgx($this$SetupCustomerMethodDialog, newMethod, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$SetupCustomerMethodDialog, newMethod), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ViewWriter() ? p1 : THROW_CCE();
        return this.sgx(tmp, p2 instanceof PaymentMethod() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    MakePaymentDialog$render$slambda$slambdaClass = $;
  }
  return MakePaymentDialog$render$slambda$slambdaClass;
}
function MakePaymentDialog$render$slambda$slambda_0(this$0) {
  var i = new (MakePaymentDialog$render$slambda$slambda())(this$0);
  var l = ($this$SetupCustomerMethodDialog, newMethod, $completion) => i.sgx($this$SetupCustomerMethodDialog, newMethod, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  var tmp = makePayment($this.uie_1, $this.vie_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.xie_1.rie_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp.y5r_1;
  var tmp_0 = 'Confirm Deposit : ' + MonetaryValue__toString_impl_xslc77(tmp$ret$0) + '?';
  confirmationDialog($this.wie_1, tmp_0, '', 'Submit Deposit', VOID, VOID, VOID, false, VOID, VOID, MakePaymentDialog$render$slambda$slambda_2($this.xie_1, $this.wie_1));
  return Unit_instance;
}
var MakePaymentDialog$render$slambda$slambdaClass_0;
function MakePaymentDialog$render$slambda$slambda_1() {
  if (MakePaymentDialog$render$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.uie_1 = this$0;
        this.vie_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentDialog$render$slambda$slambdaClass_0 = $;
  }
  return MakePaymentDialog$render$slambda$slambdaClass_0;
}
function MakePaymentDialog$render$slambda$slambda_2(this$0, $$this$button) {
  var i = new (MakePaymentDialog$render$slambda$slambda_1())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_makePayment__v18d1g($this, _this__u8e3s4, $completion) {
  var tmp = await_0($this.qie_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var method = tmp_0;
  try {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp_1 = await_0(this_0, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = tmp_1.vfw().rfg_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.rie_1;
    var tmp_3 = await_0(this_1, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var tmp$ret$1 = tmp_3.y5r_1;
    var tmp_4 = tmp_2.jfp($this.kie_1.v7a_1, new (PaymentRequest())(tmp$ret$1, method.h70_1, Companion_getInstance_2().k2p()), $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
  } catch ($p) {
    if ($p instanceof LsErrorException()) {
      var e = $p;
      if (e.vdr_1 >= 500) {
        var tmp_5 = get_dialogStack();
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_2 = StringBuilder().d1();
        // Inline function 'kotlin.text.appendLine' call
        var value = 'An unknown error occurred. A payment may have still been initiated. If a payment is not shown after 5 business days contact support to confirm if a payment was initiated.';
        // Inline function 'kotlin.text.appendLine' call
        this_2.wb(value).xb(_Char___init__impl__6a9atx(10));
        var tmp0_safe_receiver = e.message;
        var tmp_6;
        if (tmp0_safe_receiver == null) {
          tmp_6 = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_7;
          var tmp_8;
          if (isBlank(tmp0_safe_receiver)) {
            tmp_8 = true;
          } else {
            // Inline function 'kotlin.text.trim' call
            tmp_8 = toString(trim(isCharSequence(tmp0_safe_receiver) ? tmp0_safe_receiver : THROW_CCE())) === '500:';
          }
          if (!tmp_8) {
            tmp_7 = tmp0_safe_receiver;
          } else {
            tmp_7 = null;
          }
          tmp_6 = tmp_7;
        }
        var tmp1_safe_receiver = tmp_6;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.text.appendLine' call
          var value_0 = 'Reason: ' + tmp1_safe_receiver;
          // Inline function 'kotlin.text.appendLine' call
          this_2.wb(value_0).xb(_Char___init__impl__6a9atx(10));
        }
        var tmp$ret$13 = this_2.toString();
        tmp_5.gbw(GenericDialog().dgh('Payment Error', tmp$ret$13));
      } else {
        var tmp_9 = get_dialogStack();
        var tmp1_elvis_lhs = e.message;
        tmp_9.gbw(GenericDialog().bgz(tmp1_elvis_lhs == null ? 'An Unknown Error Occurred.' : tmp1_elvis_lhs));
      }
      return Unit_instance;
    } else {
      if ($p instanceof Exception()) {
        var _unused_var__etf5q3 = $p;
        get_dialogStack().gbw(GenericDialog().bgz('An unknown error occurred. A payment may have still been initiated. If a payment is not shown after 5 business days contact support to confirm if a payment was initiated.'));
        return Unit_instance;
      } else {
        throw $p;
      }
    }
  }
  get_dialogStack().gbw(GenericDialog().bgz('Deposit Confirmed. It can take 3-5 business days for the deposit to reflect in our system. Allow 3-5 business days for funds to transfer between financial institutions.'));
  return Unit_instance;
}
function makePayment($this, _this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_makePayment__v18d1g.bind(VOID, $this, _this__u8e3s4), $completion);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.yie_1 = function_0;
      }
      wi(a, b) {
        return this.yie_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.yie_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
var MakePaymentDialog$methods$slambdaClass;
function MakePaymentDialog$methods$slambda() {
  if (MakePaymentDialog$methods$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.sie_1 = this$0;
      }
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    MakePaymentDialog$methods$slambdaClass = $;
  }
  return MakePaymentDialog$methods$slambdaClass;
}
function MakePaymentDialog$methods$slambda_0(this$0) {
  var i = new (MakePaymentDialog$methods$slambda())(this$0);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
var MakePaymentDialog$render$slambdaClass;
function MakePaymentDialog$render$slambda() {
  if (MakePaymentDialog$render$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentDialog$render$slambdaClass = $;
  }
  return MakePaymentDialog$render$slambdaClass;
}
function MakePaymentDialog$render$slambda_0() {
  var i = new (MakePaymentDialog$render$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function MonetaryValueInput$_get_enabled_$ref_ui2o9t(p0) {
  return () => p0.fbs();
}
function MonetaryValueInput$_set_enabled_$ref_7ohxx(p0) {
  return (_this__u8e3s4) => {
    p0.ebs(_this__u8e3s4);
    return Unit_instance;
  };
}
function MakePaymentDialog$render$lambda(it) {
  return plus(it, null);
}
function MakePaymentDialog$render$lambda_0(it) {
  var tmp;
  if (it == null) {
    tmp = '+ New Method';
  } else {
    var tmp0_elvis_lhs = it.i70_1;
    tmp = tmp0_elvis_lhs == null ? it.h70_1 : tmp0_elvis_lhs;
  }
  return tmp;
}
function TextView$_get_shown_$ref_kipsub(p0) {
  return () => p0.yb8();
}
function TextView$_set_shown_$ref_l7jsq9(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var MakePaymentDialog$render$slambdaClass_0;
function MakePaymentDialog$render$slambda_1() {
  if (MakePaymentDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.zie_1 = this$0;
      }
      uao($completion) {
        var tmp = get_dialogStack();
        tmp.fbw(new (SetupCustomerMethodDialog())(MakePaymentDialog$render$slambda$slambda_0(this.zie_1)));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentDialog$render$slambdaClass_0 = $;
  }
  return MakePaymentDialog$render$slambdaClass_0;
}
function MakePaymentDialog$render$slambda_2(this$0) {
  var i = new (MakePaymentDialog$render$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var MakePaymentDialog$render$slambdaClass_1;
function MakePaymentDialog$render$slambda_3() {
  if (MakePaymentDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.wie_1 = $$this$button;
        this.xie_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentDialog$render$slambdaClass_1 = $;
  }
  return MakePaymentDialog$render$slambdaClass_1;
}
function MakePaymentDialog$render$slambda_4($$this$button, this$0) {
  var i = new (MakePaymentDialog$render$slambda_3())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MakePaymentDialog$render$slambdaClass_2;
function MakePaymentDialog$render$slambda_5() {
  if (MakePaymentDialog$render$slambdaClass_2 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentDialog$render$slambdaClass_2 = $;
  }
  return MakePaymentDialog$render$slambdaClass_2;
}
function MakePaymentDialog$render$slambda_6() {
  var i = new (MakePaymentDialog$render$slambda_5())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MakePaymentDialog$render$slambdaClass_3;
function MakePaymentDialog$render$slambda_7() {
  if (MakePaymentDialog$render$slambdaClass_3 === VOID) {
    class $ {
      uao($completion) {
        return Unit_instance;
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    MakePaymentDialog$render$slambdaClass_3 = $;
  }
  return MakePaymentDialog$render$slambdaClass_3;
}
function MakePaymentDialog$render$slambda_8() {
  var i = new (MakePaymentDialog$render$slambda_7())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var MakePaymentDialogClass;
function MakePaymentDialog() {
  if (MakePaymentDialogClass === VOID) {
    class $ {
      constructor(project, amount) {
        this.kie_1 = project;
        this.lie_1 = amount;
        this.mie_1 = validated(Signal().hak(new (MonetaryValue())(Companion_instance.r91(0n))));
        this.nie_1 = Signal().hak(true);
        this.oie_1 = BasicListenable().paq();
        var tmp = this;
        tmp.pie_1 = rememberSuspending(VOID, VOID, VOID, MakePaymentDialog$methods$slambda_0(this));
        var tmp_0 = this;
        tmp_0.qie_1 = mutableRemember(VOID, VOID, ($this$mutableRemember) => firstOrNull($this$mutableRemember.daj(this.pie_1)));
        var tmp_1 = this;
        tmp_1.rie_1 = remember(VOID, VOID, VOID, ($this$remember) => new (MonetaryValue())($this$remember.daj(this.nie_1) ? this.lie_1 : $this$remember.daj(this.mie_1).y5r_1));
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(MakePaymentDialog$render$slambda_0());
        view.gba(get_AppDimensions().yg1_1);
        var tmp = view.kbb(view.kbb(get_centered(view), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(30))), view.jbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.gba(get_AppDimensions().yg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        Companion_getInstance();
        // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
        var theme = get_appTheme();
        var tmp$ret$0 = new (Set())(theme);
        view_1.lba(tmp$ret$0);
        title(view_1, 'Pay With Stripe');
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(false);
        var tmp_0 = get_centered(view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.radioButton' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RadioButton())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.zah(view_3.pc7_1, this.nie_1);
        view_2.hbb(p_3, view_3);
        view_2.lbb(tmp_0, view_3);
        view_2.lbb(get_centered(view_2), body(view_2, MonetaryValue__toString_impl_xslc77(this.lie_1)));
        view_1.hbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_4 = view_1.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
        view_1.gbb(p_4, view_4);
        view_4.zbm(false);
        var tmp_1 = get_centered(view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.radioButton' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RadioButton())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.gbb(p_5, view_5);
        view_5.zah(view_5.pc7_1, equalTo(this.nie_1, false));
        view_4.hbb(p_5, view_5);
        view_4.lbb(tmp_1, view_5);
        var tmp_2 = 'Amount must be in range ' + MonetaryValueRange__toString_impl_eede0o(MonetaryValue__rangeTo_impl_1k0odj(Companion_instance.m62(1), this.lie_1));
        assertReactive(this.mie_1, tmp_2, VOID, ($this$assertReactive, it) => $this$assertReactive.daj(this.nie_1) || MonetaryValueRange__contains_impl_7d4u17(MonetaryValue__rangeTo_impl_1k0odj(Companion_instance.m62(1), this.lie_1), it.y5r_1));
        var tmp_3 = view_4.kbb(get_centered(view_4), get_compact(view_4));
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp$ret$11 = view_4.jbb(FieldSemantic_getInstance());
        var tmp_4 = view_4.kbb(tmp_3, tmp$ret$11);
        // Inline function 'com.crowpay.views.components.monetaryValueInput' call
        // Inline function 'kotlin.also' call
        var this_0 = new (MonetaryValueInput())(view_4);
        var $this$monetaryValueInput = this_0;
        reactive(view_4, ($this$reactive) => {
          var tmp;
          if (!$this$reactive.daj(this.nie_1)) {
            $this$monetaryValueInput.qb9();
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        var tmp_5 = KMutableProperty0();
        var tmp_6 = MonetaryValueInput$_get_enabled_$ref_ui2o9t($this$monetaryValueInput);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('enabled', 0, tmp_5, tmp_6, MonetaryValueInput$_set_enabled_$ref_7ohxx($this$monetaryValueInput));
        reactiveScope(view_4, ($this$reactiveScope) => {
          var tmp$ret$12 = !$this$reactiveScope.daj(this.nie_1);
          this_1.set(tmp$ret$12);
          return Unit_instance;
        });
        $this$monetaryValueInput.vcl('Partial Amount');
        view_4.zah($this$monetaryValueInput.ig9_1, this.mie_1);
        var tmp$ret$16 = this_0.lg9_1;
        view_4.lbb(tmp_4, tmp$ret$16);
        view_1.hbb(p_4, view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Space())(view_1.pc(), 0.5);
        var tmp0_elvis_lhs_6 = view_1.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_1 : tmp0_elvis_lhs_6;
        view_1.gbb(p_6, view_6);
        view_1.hbb(p_6, view_6);
        var tmp_7 = shownWhen(view_1, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.daj(this.pie_1).i1();
        });
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp$ret$25 = view_1.jbb(FieldSemantic_getInstance());
        var tmp_8 = view_1.kbb(tmp_7, tmp$ret$25);
        // Inline function 'com.lightningkite.kiteui.views.direct.select' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Select())(view_1.pc());
        var tmp0_elvis_lhs_7 = view_1.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_1 : tmp0_elvis_lhs_7;
        view_1.gbb(p_7, view_7);
        var tmp_9 = lens(this.pie_1, MakePaymentDialog$render$lambda);
        view_7.ocf(this.qie_1, tmp_9, MakePaymentDialog$render$lambda_0);
        view_1.hbb(p_7, view_7);
        view_1.lbb(tmp_8, view_7);
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (TextView())(view_1.pc());
        var tmp0_elvis_lhs_8 = view_1.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_1 : tmp0_elvis_lhs_8;
        view_1.gbb(p_8, view_8);
        view_8.lba(view_8.qb6_1.abf(BodySemantic_getInstance()));
        view_8.jb7(false);
        var tmp_10 = KMutableProperty0();
        var tmp_11 = TextView$_get_shown_$ref_kipsub(view_8);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('shown', 0, tmp_10, tmp_11, TextView$_set_shown_$ref_l7jsq9(view_8));
        reactiveScope(view_8, ($this$reactiveScope) => {
          var tmp$ret$29 = $this$reactiveScope.daj(this.pie_1).i1();
          this_2.set(tmp$ret$29);
          return Unit_instance;
        });
        view_8.dbs(Align_Center_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = 'You have no payment methods.';
        var tmp_12 = view_8.vb5_1;
        var tmp_13;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_13 = '\xA0';
        } else {
          tmp_13 = value;
        }
        tmp_12.hbu(tmp_13);
        view_1.hbb(p_8, view_8);
        var tmp_14 = view_1.kbb(shownWhen(view_1, VOID, ($this$shownWhen) => $this$shownWhen.daj(this.qie_1) == null || $this$shownWhen.daj(this.pie_1).i1()), get_secondaryButton(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (Button())(view_1.pc());
        var tmp0_elvis_lhs_9 = view_1.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_1 : tmp0_elvis_lhs_9;
        view_1.gbb(p_9, view_9);
        specCenteredText(view_9, 'Add Method');
        onClick(view_9, VOID, VOID, MakePaymentDialog$render$slambda_2(this));
        view_1.hbb(p_9, view_9);
        view_1.lbb(tmp_14, view_9);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (Space())(view_1.pc(), 0.5);
        var tmp0_elvis_lhs_10 = view_1.ebb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_1 : tmp0_elvis_lhs_10;
        view_1.gbb(p_10, view_10);
        view_1.hbb(p_10, view_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_11 = view_1.ebb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_1 : tmp0_elvis_lhs_11;
        view_1.gbb(p_11, view_11);
        view_11.zbm(false);
        view_11.bb9(get_AppDimensions().kg2_1);
        var tmp_15 = get_primaryButton(view_11);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (Button())(view_11.pc());
        var tmp0_elvis_lhs_12 = view_11.ebb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
        view_11.gbb(p_12, view_12);
        var tmp_16 = KMutableProperty0();
        var tmp_17 = Button$_get_enabled_$ref_61t7nx(view_12);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_3 = getPropertyCallableRef('enabled', 0, tmp_16, tmp_17, Button$_set_enabled_$ref_o8kynz(view_12));
        reactiveScope(view_12, ($this$reactiveScope) => {
          var tmp;
          if ($this$reactiveScope.daj(get_issues(this.mie_1)).i1()) {
            var tmp_0;
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!$this$reactiveScope.daj(this.pie_1).i1()) {
              tmp_0 = !($this$reactiveScope.daj(this.qie_1) == null);
            } else {
              tmp_0 = false;
            }
            tmp = tmp_0;
          } else {
            tmp = false;
          }
          var tmp$ret$45 = tmp;
          this_3.set(tmp$ret$45);
          return Unit_instance;
        });
        specCenteredText(view_12, 'Submit Deposit');
        onClick(view_12, VOID, VOID, MakePaymentDialog$render$slambda_4(view_12, this));
        view_11.hbb(p_12, view_12);
        view_11.lbb(tmp_15, view_12);
        var tmp_18 = get_textButton(view_11);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (Button())(view_11.pc());
        var tmp0_elvis_lhs_13 = view_11.ebb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_11 : tmp0_elvis_lhs_13;
        view_11.gbb(p_13, view_13);
        specCenteredText(view_13, 'Go Back');
        onClick(view_13, VOID, VOID, MakePaymentDialog$render$slambda_6());
        view_11.hbb(p_13, view_13);
        view_11.lbb(tmp_18, view_13);
        view_1.hbb(p_11, view_11);
        view_0.hbb(p_1, view_1);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        view.vbo(MakePaymentDialog$render$slambda_8());
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'MakePaymentDialog', VOID, VOID, [Page()], [1]);
    MakePaymentDialogClass = $;
  }
  return MakePaymentDialogClass;
}
//region block: exports
export {
  MakePaymentInfoBandaidDialog as MakePaymentInfoBandaidDialog18vq2rlet73fk,
  PayForChange as PayForChange3tpjo85o3asyb,
  PayRequested as PayRequested65fjypdtje6w,
  PayRemainingToCompleteProject_getInstance as PayRemainingToCompleteProject_getInstance86isfd7phkqn,
  PayUnrequested_getInstance as PayUnrequested_getInstance3elwvp0p6ot2o,
};
//endregion

//# sourceMappingURL=MakePaymentDialog.mjs.map
